import axios from 'axios';

/*
* admin sign in
* */
export const signIn = (data, config={})=>axios.post(`/api/user/login`, data, config);

/*
* admin logout
* */
export const signOut = (data, config={})=>axios.post(`/api/user/logout`, data, config);

/*
* regular sign in
* */
export const regularSignIn = (data, config={})=>axios.post(`/api/user/regularLogin`, data, config);

/*
* register
* */
export const partnerRegister = (data, config={})=>axios.post(`/api/user/regist`, data, config);

/*
* saveGeneralUserSubscriber
* */
export const saveGeneralUserSubscriber = (data, config={})=>axios.post(`/api/subscribe/saveGeneralUserSubscriber`, data, config);

/*
* unSubscriberbyGeneralUser
* */
export const unSubscriberbyGeneralUser = (data, config={})=>axios.post(`/api/subscribe/unSubscriberbyGeneralUser`, data, config);

/*
* initSubscribe
* */
// export const initSubscribe = () => axios.get(`/api/subscribe/subscription`);

/*
* sendAccessToken
* */
export const sendAccessToken = (data, config) => axios.post(`/api/user/sendAccessToken`,data, config);

/*
* get tenant all
* */
export const getAllTenant = data => axios.post(`/api/tenant/all`, data);

/*
* fileUpload
* */
export const fileUpload = (data, config) => axios.post(`/api/common/fileUpload`, data, config);

/*
* add new tenant
* */
export const addNewTenant = (data, config) => axios.post(`/api/tenant/add`, data, config);

/*
* tenant detail
* */
export const tenantDetail = (data, config) => axios.post(`/api/tenant/detail`, data, config);

/*
* delete tenant
* */
export const deleteTenant = data => axios.post(`/api/tenant/delete`, data);

/*
* get tenant info
* */
export const getTenantInfo = (data, config) => axios.post(`/api/tenant/getTenantInfo`, data, config);

/*
* check token
* */
export const userInfo = () => axios.get(`/api/user/info`);

/*
* get subscriber all
* */
export const findSubscriberList = data => axios.post(`/api/subscribe/findSubscriberList`, data);

/*
* get addSubscriber need token
* */
export const addSubscriber = data => axios.post(`/api/subscribe/addSubscriber`, data);

/*
* get addSubscriber regional admin
* */
export const addSubGeneral = data => axios.post(`/api/subscribe/addSubscriberbyGeneralUser`, data);

/*
* get changeSubStatus
* */
export const changeSubStatus = data => axios.post(`/api/subscribe/changeSubStatus`, data);

/*
* delete subscribers
* */
export const deleteSubscribers = data => axios.post(`/api/subscribe/deleteSubscribers`, data);

/*
* updatePassword
* */
export const updatePassword = data => axios.post(`/api/user/updatePassword`, data);

/*
* regularSubmit
* */
export const regularSubmit = data => axios.post(`/api/subscribe/regularSubmit`, data);

/*
* scriberCountsByDay
* */
export const scriberCountsByDay = (data, config) => axios.post(`/api/subscribe/scriberCountsByDay`, data, config);

/*
* subscribFlagAndStatusCounts
* */
export const flagAndCounts = (data, config) => axios.post(`/api/subscribe/subscribFlagAndStatusCounts`, data, config);

/*
* sendEmailCounts
* */
export const sendEmailCounts = (data, config) => axios.post(`/api/subscribe/sendEmailCounts`, data, config);

/*
* get bounce email list
* */
export const bounceEmailList = (data, config) => axios.post(`/api/bounces/list`, data, config);

/*
* delete bounce email by email address
* */
export const deleteBounceEmail = (data, config) => axios.post(`/api/bounces/del`, data, config);



// WEBPACK FOOTER //
// ./src/api/index.js